// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found {
  text-align: center;
  padding: 20px;
}
.not-found h2 {
  color: #484848;
}
.not-found ng-lottie {
  display: flex;
  align-items: center;
  justify-content: center;
}
.not-found .list-link h6 {
  color: #484848;
}
.not-found .list-link .links {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
.not-found .list-link .links a {
  padding: 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/not-found/not-found.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;AACF;AAAE;EACE,cAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAEI;EACE,cAAA;AAAN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AACM;EACE,iBAAA;AACR","sourcesContent":[".not-found {\n  text-align: center;\n  padding: 20px;\n  h2 {\n    color: #484848;\n  }\n\n  ng-lottie {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .list-link {\n    h6 {\n      color: #484848;\n    }\n    .links {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n      a {\n        padding: 0px 10px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
